





























import Vue from 'vue';
import Tabs from "@/components/Money/Tabs.vue";
import {Component} from 'vue-property-decorator';
import recordTypeList from '@/constants/recordTypeList';
import { Tag } from '@/views/custom';


@Component({
  components: {Tabs}
})
export default class Edit extends Vue {
  type = 'expense'
  recordTypeList = recordTypeList;

  get filteredList() {
    this.$store.commit('fetchTags')
    return this.$store.state.tagList.filter((tag: Tag) => tag.type === this.type)
  }
addTag(){
    this.$router.push(`/money/edit/add/${this.type}`)
}
  deleteTag(tag: Tag) {
    const _this= this;
    this.$confirm({
      content: '确定要删除该标签吗?',
      okText: '确定',
      cancelText: "取消",
      centered:true,
      onOk(){
        _this.$store.commit('deleteTag', tag)
        _this.$message.success({content: '已删除',duration:1});
      }
    })


  }
}
